import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import topic from 'dojo/topic';
import "./EvBookingEditorTypes";

import '../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingEditor as EvBookingEditorV2, EvBookingCopyForm } from "../_loadingHelpers/VAMv2";
import { VAM2types, VAMclassNames } from "../_loadingHelpers/VAMv2Types";
import ProjectReportOptionsForm from '../ProjectWizard/ProjectReportOptionsForm/ProjectReportOptionsForm';
import BookingReportOptionsForm from '../ProjectWizard/BookingReportOptionsForm/BookingReportOptionsForm';
import _EntityViewMixin from '../../moreCore/UI/EntityBased/EntityView/EntityView';
import filePreview from '../filePreview/filePreview';
import { FileHelpers } from "../../more/Helpers";
import emailForm from '../EMail/emailForm';
import { EmailEditorTypes } from "../EMail/emailTypes";
import { SelectEntityDialog, SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import _WidgetBase from 'dijit/_WidgetBase';

class EvBookingView extends compose(_EntityViewMixin<VAM2types.EvBooking_Base>) {
    //templateString = template;

    //private entityID: string = null;
    //private entity: VAMtypes.EvBookingEntity_Short = null;
    //private dlg: GenericDialog = null;
    private _loadingRequest: dojo.request.Promise<any> = null;
    private editingVisible: boolean = false;

    private actionNode: HTMLElement;
    private contentNode: HTMLElement;
    private btnDelete: HTMLButtonElement;

    private mailform: MdsLax<InstanceType<typeof emailForm>>;

    private _additionalRequestParams: Object = null;

   /**
    *
    * @param entityId
    * @param label
    * @param additionalParams
    * @param tabContainerName Name des Tabcontainers, in die die Ansicht ggf. maximiert werden kann
    * @param contextName Beliebiger Kontextname, der im Backend eine Differenzierung zum Zweck der Ansicht zulässt
    * @param disableDefaultButtons Entfernt die Standardbuttons für Reports, Löschen und sonstige Entity-Interaktionen. Neue Buttons können mit addButton eingefügt werden.
    */
    setup(entityId: string,
        label: string,
        additionalParams?: Object,
        contextName?: string,
        tabContainerName?: string) {

        if (additionalParams) {
            this.config.additionalRequestParams = lang.clone(additionalParams);
        }

        if (contextName) this.setContextName(contextName);

        this.showAsDlg(entityId, label, tabContainerName);
       
    }



    onShow() {
        if (this.useDefaultButtons !== false) {
            this.handleAdditionalButtons();
        }        
    }

    private handleAdditionalButtons() {


        //if (this.hasUserRole(["EvBooking_Create", "EvBooking_Edit"]) && this.entity && this.hasFeature("EvBooking/Copy")) {

        //    this.addButton(
        //        "copy",
        //        this.translations["BookingEditor__CopyEvBooking"],
        //        lang.hitch(this, this.startCloneProcess, this.entity),
        //        null,
        //        null,
        //        "fas fa-clone",
        //        false,
        //        "left last");
        //}

        if (!this.entity) {
            //this.disableButton("copy");
        }

        /*if (this.hasUserRole("OM_Matrix")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: window.translations["OM__SchedulerMatrix"],
                    callback: lang.hitch(this, function () {
                        //this.StandbyStart(this.itemClickDlg.domNode);
                        //this.itemClickDlg.close();
                        window.location.href = window.appRoot + "Home/OM?directBookingId=" + this.entityID
                    }),
                    placement: "actionbar",
                    iconClass: "fas fa-border-none",
                    permanent: false
                });
            } else if( this.dlg) {
                this.dlg.addButton(
                    "gotoMatrix",
                    window.translations["OM__SchedulerMatrix"],
                    lang.hitch(this, function () {
                        //this.StandbyStart(this.itemClickDlg.domNode);
                        //this.itemClickDlg.close();
                        window.location.href = window.appRoot + "Home/OM?directBookingId=" + this.entityID
                    }),
                    null,
                    null,
                    "fas fa-border-none",
                    false,
                    "left first"
                );
            }
        }*/

        // Report-Download machen
        if (this.hasFeature("EvProject/ProjectReport")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: this.translations["General_Label_ProjectReport"],
                    callback: lang.hitch(this, this._requestProjectReport, null),
                    placement: "actionbar",
                    iconClass: "fas fa-print",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("report",
                    this.translations["General_Label_ProjectReport"],
                    lang.hitch(this, this._requestProjectReport, null),
                    null, null,
                    "fas fa-print",
                    false,
                    "left last");
            }
        }
        if (this.hasFeature("EvProject/ProjectReportShort")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: "General_Label_ProjectReportShort",
                    callback: lang.hitch(this, this._requestProjectReport, "projectReportShort"),
                    placement: "actionbar",
                    iconClass: "fas fa-print",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("reportShort",
                    "General_Label_ProjectReportShort",
                    lang.hitch(this, this._requestProjectReport, "projectReportShort"),
                    null, null,
                    "fas fa-print",
                    false,
                    "left last");
            }
        }
        if (this.hasFeature("EvBooking/BookingReport")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: this.translations["General_Label_BookingReport"],
                    callback: lang.hitch(this, this._requestBookingReport),
                    placement: "actionbar",
                    iconClass: "fas fa-print",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("bookingReport",
                    this.translations["General_Label_BookingReport"],
                    lang.hitch(this, this._requestBookingReport),
                    null, null,
                    "fas fa-print",
                    false,
                    "left last");
            }
        }

        if (this.hasFeature("EvBooking/ConcertInfoReport")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: this.translations["General_Label_ConcertInfoReport"],
                    callback: lang.hitch(this, this._requestConcertInfoReport),
                    placement: "actionbar",
                    iconClass: "fas fa-print",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("concertInforReport",
                    this.translations["General_Label_ConcertInfoReport"],
                    lang.hitch(this, this._requestConcertInfoReport),
                    null, null,
                    "fas fa-print",
                    false,
                    "left last");
            }
        }

        if (this.hasFeature("EvBooking/AttendanceList")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: this.translations["General_Label_AttendanceList"],
                    callback: lang.hitch(this, this._generateAttendanceList),
                    placement: "actionbar",
                    iconClass: "fas fa-users",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("attendanceList",
                    this.translations["General_Label_AttendanceList"],
                    lang.hitch(this, this._generateAttendanceList),
                    null, null,
                    "fas fa-users",
                    false,
                    "left last");
            }
        }

        if (this.hasFeature("EvBooking/TravelListReport")) {
            if (this.isEmbeddedInTab) {
                this.createContextButton({
                    label: this.translate("WebCalender_BtnLabel_TravelListReport"),
                    tooltip: this.translate("WebCalender_BtnTitle_TravelListReport"),
                    callback: lang.hitch(this, this._prepareReportRequest, "travelList"),
                    placement: "actionbar",
                    iconClass: "fas fa-download",
                    permanent: false
                });
            } else if (this.dlg) {
                this.dlg.addButton("attendanceList",
                    this.translate("WebCalender_BtnLabel_TravelListReport"),
                    lang.hitch(this, this._prepareReportRequest, "travelList"),
                    this.translate("WebCalender_BtnTitle_TravelListReport"),
                    null,
                    "fas fa-download",
                    false,
                    "left last");
            }
        }

        if (this.hasFeature("Email", "BookingView_CreateMail") && this.hasUserRole("Email_Editor")) {
            this.addButtonMenu("email", "Email", "fas fa-at", true, null);

            this.addButton("email",
                "email_mailFormStandalone_CreateNew",
                lang.hitch(this, this.showMailEditor, this.title),
                null,
                null,
                "fas fa-envelope-open-text",
                false,
                "left first",
                true,
                false,
                true,
                "email");

            if (this.hasFeature("Email", "BookingView_BulkMail")) {
                this.addButtonMenu("bulkmailOrchestraEmployments", this.translate("BulkMai_Label_OrchestraEmployments"), "fas fa-guitar", true, "email");
                this.addButton("autoOrchestraEmployments", this.translate("BulkMail_Label_Auto"), lang.hitch(this, this._onClickBulkMailBtn, "booking_orchestraEmployment", true), null, null, "fas fa-mail-bulk", false, "left last", true, false, true, "bulkmailOrchestraEmployments");
                this.addButton("sendMailToRelatedAddress", this.translate("BulkMail_Label_Select"), lang.hitch(this, this._onClickBulkMailBtn, "booking_orchestraEmployment", false), null, null, "fas fa-mouse-pointer", false, "left last", true, false, true, "bulkmailOrchestraEmployments");
            }
        }
    }

    private _generateAttendanceList(evt: MouseEvent) {
        this.RequestManager.callfunction("Webtool_API_EvBooking__GenerateAttendanceList", {
            bookingID: this.entityID
        },
            lang.hitch(this, this._onGenerateAttendanceListResponse), lang.hitch(this, this._onGenerateAttendanceListError));
    }

    private _onGenerateAttendanceListResponse(response: FileFinder.FileDescriptorWithBase64) {
        if (!response) {
            this._onGenerateAttendanceListError(response);
        }
        else if (response.downloadKey || response.base64Content) {
            this.showToast("EvBooking_Success_AttendanceList", "fas fa-check");
            this._downloadReport(response);
        }
    }

    private _onGenerateAttendanceListError(error) {
        this.showToast("EvBooking_Error_AttendanceList", "fas fa-exclamation-triangle")
    }

    private _requestConcertInfoReport(evt: MouseEvent) {
        this._prepareReportRequest("concertInfoReport")
    }

    private _requestBookingReport(evt: MouseEvent) {
        this._prepareReportRequest("bookingReport");
    }

    private _requestProjectReport(overrideType: string, evt: MouseEvent) {

        this._prepareReportRequest(overrideType ? overrideType as any : "projectReport");
    }

    private _prepareReportRequest(type: "projectReport" | "projectReportShort" | "bookingReport" | "concertInfoReport" | "travelList") {

        this.StandbyStart(this.dlg ? this.dlg.actionContainerNode : this.contentNode);
        let url: string;
        let callfunction: string;

        switch (type) {
            case "projectReport":
                url = window.appRoot + "Downloads/ProjectReport";
                if (this.hasFeature("EvProject/ProjectReportOptions") === true) {

                    let optionsDlg = new ProjectReportOptionsForm();
                    optionsDlg.displayOptionsDialog(this.entityID, lang.hitch(this, this._sendReportRequest, url));
                    optionsDlg.on("projectreport_cancelled", () => { this.StandbyStop(); });
                    return;
                }
                break;
            case "projectReportShort":
                url = window.appRoot + "Downloads/ProjectReport";
                break;

            case "bookingReport":
                url = window.appRoot + "Downloads/BookingReport";
                if (this.hasFeature("EvBooking/BookingReportOptions") === true) {

                    let optionsDlg = new BookingReportOptionsForm();
                    optionsDlg.displayOptionsDialog(url, this.entityID, lang.hitch(this, this._sendReportRequest));
                    optionsDlg.on("bookingreport_cancelled", () => { this.StandbyStop(); });
                    return;
                }
                break;
            case "concertInfoReport":
                callfunction = "Webtool_API_EvBooking__GetConcertInfoReport";
                this.RequestManager.callfunction(callfunction, { bookingID: this.entityID }, lang.hitch(this, this._onDownloadReady), lang.hitch(this, this._onRequestReportError));
                return;
                break;
            case "travelList":
                url = window.appRoot + "Calendar/RequestTravelListReport";
                break;
        }

        //let url = window.appRoot + "Downloads/ProjectReport";

        let data = { "bookingID": this.entityID, "type": type };
        let stringData = JSON.stringify(data);

        this._sendReportRequest(url, stringData);
    }

    private showMailEditor(subject?: string, content?: string, isBulkMail = false) {
        //TODO weniga gage email addresse rauspicken
        try {
            var targetMailForMailButton = this.viewData.content.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)[0];
        } catch {

        }
        this.mailform = new emailForm();
        this.mailform.setMailFormContext({
            isHistoryContext: true,
            contextEntity: {
                ID: this.entityID,
                Classname: this.config.entityClassname
            }
        });


        if (targetMailForMailButton && !isBulkMail) {
            this.mailform.addRecipients("to", [{ mailaddress: targetMailForMailButton, entityID: null }]);
        } else if (!isBulkMail) {
            this.mailform.loadRecipientAddress("to", this.entityID);
        }

        if (typeof subject == 'string') {
            this.mailform.setSubject(subject);
        }
        if (typeof content == 'string') {
            this.mailform.addContent(content);
        }

        this.mailform.show("dlg", null, this.getTabContainerName());

    }

    private _onClickBulkMailBtn(mode: string, autoSelect: boolean) {
        if (autoSelect) this.RequestManager.callfunction("Webtool_API_BulkMail_GetMailAddresses", { mode, entityId: this.entityID }, lang.hitch(this, this._onRequestEmailAddressesResponse), lang.hitch(this, this._onRequestEmailAddressesError));
        else this.RequestManager.callfunction("Webtool_API_BulkMail_SED_GetConfig", { mode }, lang.hitch(this, this._onSEDConfigResponse, mode), lang.hitch(this, this._onSEDConfigError));
    }

    private _onRequestEmailAddressesResponse(response: Array<UserEmail>) {
        this.StandbyStop();
        let mailAddressArray: Array<EmailEditorTypes.mailRecipient> = [];
        for (let address of response) {
            mailAddressArray.push({ entityID: address.ID, mailaddress: address.telecom_code });
        }
        this.showMailEditor(this.title, null, true);
        this.mailform.setToBulkmail(null, mailAddressArray);
    }

    private _onRequestEmailAddressesError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onSEDConfigResponse(mode: string, response: SelectEntityDialogTypes.DlgConfiguration<any>) {
        let selectEntityDialog = new SelectEntityDialog();
        selectEntityDialog.setConfiguration(response, lang.hitch(this, this._onSEDCallback, mode));
        selectEntityDialog.addRequestParameter("mode", mode);
        selectEntityDialog.addRequestParameter("entityId", this.entityID);
        selectEntityDialog.show();
    }

    private _onSEDConfigError(error) {
        console.error(error);
    }

    private _onSEDCallback(mode: string, values: Array<string>, items: Array<SelectEntityDialogTypes.Item<UserEmail>>) {
        let mailAddressArray: Array<EmailEditorTypes.mailRecipient> = [];
        switch (mode) {
            case "booking_orchestraEmployment":
                for (let item of items) {
                    mailAddressArray.push({ entityID: item.entry.data.ID, mailaddress: item.entry.data.telecom_code });
                }
                this.showMailEditor(this.title, null, true);
                this.mailform.setToBulkmail(mailAddressArray);
                break;
        }
    }

    private _downloadReport(data: FileFinder.FileDescriptorWithBase64) {
        this.StandbyStop();

        FileHelpers.provideFile(data);
    }

    private _sendReportRequest(url: string, stringData: string): void {

        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onDownloadReady),
            lang.hitch(this, this._onRequestReportError),
            false // sync
        );
    }

    private filePreview:MdsLax<InstanceType<typeof filePreview>>;
    private _onDownloadReady(entity: FileFinder.FileDescriptor) {
        //debugger;
        this.StandbyStop();
        //console.log("_onClick_Download", entity);
        if (this.hasFeature("filePreview", "useInEvBookingView") == false){
            location.href = window.appRoot + this.stringFormat("FileDashboard/Download?downloadKey={0}&fileName={1}.{2}",
                entity.downloadKey,
                entity.filename,
                entity.extension);
        }else{
            this.filePreview = new filePreview();
            this.filePreview.show(
                {key: entity.downloadKey},
                true,
                true,
                null,
                null
            );
        }

    }

    private _onRequestReportError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }
    protected onRequestEditor(entityID: string, entity): MdsLax<InstanceType<typeof _WidgetBase>> {

        let editor = new EvBookingEditorV2();

        //editor.startup();
        if (!this.isEmbeddedInTab) this.tryMoveToTab(false);

        if (this.isEmbeddedInTab) {
            this.createNewTabbedContent({
                widget: editor,
                enableClosing: true,
                label: this.title,
                name: this.internalName,
                coloration: null,
                groupLabel: this.groupLabel,
                iconclass: "fas fa-edit",
                sidebarEntryName: this.internalName,
                targetContainerName: this.getTabContainerName()
            }, true, true);
        }

        editor.loadEntityById(this.entityID);

        editor.on("requestCopy", lang.hitch(this, this.startCloneProcess));
        editor.on("saved", lang.hitch(this, this._onEditorSaved));
        editor.on("closed", lang.hitch(this, this._onClosing));

        return editor;
    }



    private _onEditorSaved(response) {
        this.emit("saved", response);
        //this.reload();
    }

    protected onClone() {
        this.startCloneProcess();
    }
    startCloneProcess(entity?: VAM2types.EvBooking_Base): void {

        if (entity) this.entity = entity;

        entity = this.entity;

        if (!entity && !this.entityID) return;

        if (!this.hasFeature("EvBooking/Copy")) return;

        // Generationenkonflikt: VAM sagt das date ist ein String, VAM2 sagt, das date ist ein Date
        // die neue Copyform will Typ 2. je nachdem woher wir kommen könnte es beides sein.
        // sicherheitshalber string-dates mal vorher umwandeln:

        if (entity) {
            if (typeof (entity.date_start) == "string") {
                (<any>entity).date_start = new Date(entity.date_start);
            }
            if (typeof (entity.date_end) == "string") {
                (<any>entity).date_end = new Date(entity.date_end);
            }
        }

        let cloneForm = new EvBookingCopyForm();

        if (!entity) {
            cloneForm.setupFromID(this.entityID);
        } else {
            cloneForm.setup(entity as any);
        }

        cloneForm.on("saved", lang.hitch(this, this._onSavedClone));
    }

    private _onSavedClone(entityID: string) {
        //this.load();
        this.afterClone();
        this.emit("saved");
    }



    afterDelete() {
        topic.publish("EvBooking/Deleted", this.entity);
    }



    private _onDeleteEvBookingError(error: more.requestErrorMessage) {
        this.StandbyStop();

        alert(error.Message);
    }


    postCreate(): void {

        this.config = {
            entityClassname: VAMclassNames.ev_booking,
            labelProperty: "ev_booking_name",
            entityClassPrintname: this.translate("General_Label_EvBooking"),
            cloneOptions: {
                userroleClone: "EvBooking_Create",
                featurePathClone: "Evbooking/Copy",
            },
            editOptions: {
                userroleEdit: "EvBooking_Edit",
                featurePathEdit: null,//"EvBooking/EvBookingEditor",
                onChangedEventName: "change",
                onSavedEventName: "saved",
                onDeletedEventName: "deleted"
            },
            deleteOptions: {
                userroleDelete: "EvBooking_Delete",
                featurePathDelete: null,
            }            
            
            
            //requestDataFunctionname:"Webtool_API_Appointments__GetEntityData"
        }
        super.postCreate.apply(this, arguments as any);


    //    this.checkPrivileges();
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingView);
